import StepCard from "./components/StepCard";
import teamImg from "../../../assets/img/apponboarding/member.png";

const StepAddTeam = ({ onCtaClick, onSkip, isCtaLoading, stepNumber, totalSteps, selectedOrganization }) => {
  return (
    <StepCard
      stepLabel={`Step ${stepNumber}`}
      title="Add Team"
      description="Teams help you organize your employees in the organization into different teams or departments, the way you like."
      ctaLabel="Add Team"
      onCtaClick={onCtaClick}
      onSkip={onSkip}
      isCtaLoading={isCtaLoading}
      mediaSrc={null}
      selectedOrganization={selectedOrganization}
      backgroundColor="#F0E6FF"
      backgroundImage={teamImg}
      videoUrl="https://youtu.be/UHiBgSAz-RI"
    />
  );
};

export default StepAddTeam;
